import api from '@/lib/axios';

export interface CreateUserData {
  companyId: string;
  branchId?: string;
  roleId: string;
  username: string;
  email: string;
  password: string;
  fullName: string;
}

export interface UpdateUserData {
  branchId?: string;
  roleId?: string;
  username?: string;
  email?: string;
  password?: string;
  fullName?: string;
}

export const usuariosService = {
  async findAll(companyId: string, branchId?: string) {
    const response = await api.get('/users', { params: { companyId, branchId } });
    return response.data;
  },

  async findById(id: string) {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },

  async create(data: CreateUserData) {
    const response = await api.post('/users', data);
    return response.data;
  },

  async update(id: string, data: UpdateUserData) {
    const response = await api.patch(`/users/${id}`, data);
    return response.data;
  },

  async deactivate(id: string) {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  },

  async getRoles(companyId: string) {
    const response = await api.get(`/roles/company/${companyId}`);
    return response.data;
  },

  async getBranches(companyId: string) {
    const response = await api.get(`/branches/company/${companyId}`);
    return response.data;
  },
};
